import { SMALL_TABLET_SCREEN_SIZE } from "../../../AppNavigation/constants";
import { useTheme, styled } from "@mui/material/styles";
import React from "react";

const StyledBrandclubButton = styled("button")(({ theme }) => ({
  marginLeft: 6,
  height: 55,
  width: 250,
  color: "white",
  border: "none",
  outline: "none",
  fontSize: 22,
  fontWeight: 500,
  cursor: "pointer",
  position: "relative",
  backgroundColor: "transparent",
  "& span": {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    borderRadius: 200,
    width: "100%",
  },
  "& > span:nth-child(2)": {
    display: "grid",
    placeItems: "center",
    transform: "translate(-6px, -6px)",
    transition: "transform 0.2s ease-in-out",
  },
  "&:hover > span:nth-child(2)": {
    transform: "translate(-3px, -3px)",
  },
  "&:active > span:nth-child(2)": {
    transform: "translate(0, 0)",
  },
  "@media only screen and (max-width: 1279px)": {
    width: 203,
    height: 44,
    "> span:nth-child(2)": {
      fontSize: 17,
    },
  },
  [`@media only screen and (max-width: ${SMALL_TABLET_SCREEN_SIZE}px)`]: {
    width: 164,
    height: 43,
    "> span:nth-child(2)": {
      fontSize: 16,
    },
  },
  "@media only screen and (min-width: 1280px)": {
    width: 251,
    height: 55,
    "> span:nth-child(2)": {
      fontSize: 22,
    },
  },
}));

type StyledBrandclubButtonProps = React.ComponentProps<
  typeof StyledBrandclubButton
>;

interface BrandClubButtonProps extends StyledBrandclubButtonProps {
  text: string;
  shapeColor: string;
}

const BrandClubButton = ({
  text,
  onClick,
  shapeColor,
  style,
  ...props
}: BrandClubButtonProps) => {
  const theme = useTheme();
  const { backgroundColor, color, border, fontSize, ...restStyle } =
    style ?? {};
  return (
    <StyledBrandclubButton
      style={{ width: 179, height: 47, marginTop: 20, ...restStyle }}
      {...props}
      onClick={onClick}
    >
      <span style={{ backgroundColor: shapeColor }}></span>
      <span
        style={{
          backgroundColor: backgroundColor || "#fff",
          fontSize: fontSize || 18,
          color: color || theme.vars.palette.primary.main,
          border: border || `2px solid ${theme.vars.palette.primary.main}`,
        }}
      >
        {text}
      </span>
    </StyledBrandclubButton>
  );
};

export default BrandClubButton;
